// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gtjXe","col":"styles_col__mCOfX"};